import _ from 'lodash';
import xss from 'xss';
import linkifyHtml from 'linkify-html';

function titleize() {
  return _.startCase(_.toLower(this));
}

function toReactHtml(this: string, { linkify, highlight }: { linkify?: boolean, highlight?: string } = {}) {
  let html = xss(this, { whiteList: { mark: [], b: [], i: [] } });
  if (highlight) {
    const openingTag = '<mark>';
    const closingTag = '</mark>';
    Array.from(this.matchAll(new RegExp(_.escapeRegExp(highlight), 'ig'))).map(({ index }) => index).forEach((strIndex, ix) => {
      const adjustedIndex = strIndex + ix * (openingTag.length + closingTag.length);
      html = ''
        + html.substring(0, adjustedIndex)
        + openingTag
        + html.substring(adjustedIndex, adjustedIndex + highlight.length)
        + closingTag
        + html.substring(adjustedIndex + highlight.length);
    });
  }
  if (linkify) {
    html = linkifyHtml(html, {
      validate: {
        url: (value: string) => /^https?:\/\/([^"'\[\]\{\};<>]|&amp;)*$/.test(value),
      },
      rel: 'noopener noreferrer',
      target: '_blank',
    });
  }
  return { __html: html };
}

function hashCode(this: string) {
  // simple SDBM hash implementation
  return this.split('').reduce(
    (acc, currentVal) =>
      currentVal.charCodeAt(0) + (acc << 6) + (acc << 16) - acc,
    0,
  );
}

declare global {
  interface String {
    titleize: typeof titleize;
    toReactHtml: typeof toReactHtml;
    hashCode: typeof hashCode;
  }
}

Object.assign(String.prototype, { titleize, toReactHtml, hashCode });
